import { eventNames, useCoreEvents } from '@carvana/core-events';
import { useState } from 'react';

/**
 * Hook to track when the account modal MFE is ready.
 * The accountModal.ready event fires once the modal infrastructure is loaded.
 */
export default function useAccountModalReady(): boolean {
  const [isReady, setIsReady] = useState(false);

  useCoreEvents(
    eventNames.accountModal.ready,
    () => {
      setIsReady(true);
    },
    { withHistory: true }
  );

  return isReady;
}
